import { render } from "./LibraryDocuments.vue?vue&type=template&id=05bfb04f&scoped=true&ts=true"
import script from "./LibraryDocuments.vue?vue&type=script&lang=ts"
export * from "./LibraryDocuments.vue?vue&type=script&lang=ts"

import "./LibraryDocuments.vue?vue&type=style&index=0&id=05bfb04f&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bfb04f"]])

export default __exports__